import { type ComputedRef, provide, inject } from "vue";
import { createProvideInjectKey } from "~/utils/provideInjectKey.ts";

export const LANG_DIR_SYMBOL = createProvideInjectKey<ComputedRef<"rtl" | "ltr">>("langDir");
export function useProvideLangDir(value: ComputedRef<"rtl" | "ltr">) {
  provide(LANG_DIR_SYMBOL, value);
}

export function useInjectLangDir() {
  return inject(
    LANG_DIR_SYMBOL,
    computed(() => "ltr"),
  );
}

export const BREADCRUMB_UPDATE_METHOD =
  createProvideInjectKey<(title: string, url?: string) => void>("breadcrumb update method");

export function useProvideBreadcrumbUpdate(breadcrumbTitle: Ref<string>, breadcrumbUrl: Ref<string | undefined>) {
  const updateBreadcrumb = (title: string, url?: string) => {
    breadcrumbTitle.value = title;
    breadcrumbUrl.value = url;
  };
  return provide(BREADCRUMB_UPDATE_METHOD, updateBreadcrumb);
}

export function useBreadcrumbUpdate(title: MaybeRef<string>, url?: MaybeRef<string | undefined>) {
  const updateBreadcrumb = inject(BREADCRUMB_UPDATE_METHOD, (title: string, url?: string) => {
    devConsole.warn(
      `useInjectBreadcrumbUpdate called with nothing provided! arguments: ${JSON.stringify({ title, url })}`,
    );
  });

  onMounted(() => {
    updateBreadcrumb(unref(title), unref(url));
  });

  onActivated(() => {
    updateBreadcrumb(unref(title), unref(url));
  });
}

export const NESTED_CHECKBOX_REGISTER =
  createProvideInjectKey<(value: Ref<boolean>) => void>("NestedCheckbox:register");
export const NESTED_CHECKBOX_UNREGISTER =
  createProvideInjectKey<(value: Ref<boolean>) => void>("NestedCheckbox:unregister");
export const NESTED_IDS_REGISTER = createProvideInjectKey<(value: string) => void>("NestedCheckbox:registerIds");
export const NESTED_IDS_UNREGISTER = createProvideInjectKey<(value: string) => void>("NestedCheckbox:unregisterIds");
